import {EntityFactory, Reducer} from '@modifi/redux'
import {getAuthenticatedShipmentsClient} from '../../lib'

const apiClient = getAuthenticatedShipmentsClient()

const {reducer, actions, selectors} = EntityFactory({
  rootSelector: state => state?.data?.shipmentDetails?.entity,
  actionNamePrefix: 'data/shipment-details/entity',
  fetchRequest: (state, params: {externalShipmentId: string}) => {
    const {externalShipmentId} = params

    return apiClient.ShipmentDetails.byId({externalShipmentId}).then(res => res.data())
  },
})

export default reducer as Reducer

export const {
  selectEntity: selectShipmentDetails,
  selectIsLoading: selectShipmentDetailsAreLoading,
  selectIsError: selectShipmentDetailsHasError,
} = selectors

export const aFetchShipmentDetails = (externalShipmentId: string): any =>
  actions!.fetch({externalShipmentId})

export const aClearShipmentDetails = (): any => actions!.clear()
